/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sidebar_Guide_Vs_FormatsInputs */

const en_sidebar_guide_vs_formats = /** @type {(inputs: Sidebar_Guide_Vs_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON vs YAML vs XML`)
};

const ko_sidebar_guide_vs_formats = /** @type {(inputs: Sidebar_Guide_Vs_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON vs YAML vs XML`)
};

const ja_sidebar_guide_vs_formats = /** @type {(inputs: Sidebar_Guide_Vs_FormatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON vs YAML vs XML`)
};

/**
* | output |
* | --- |
* | "JSON vs YAML vs XML" |
*
* @param {Sidebar_Guide_Vs_FormatsInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const sidebar_guide_vs_formats = /** @type {((inputs?: Sidebar_Guide_Vs_FormatsInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sidebar_Guide_Vs_FormatsInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sidebar_guide_vs_formats(inputs)
	if (locale === "ko") return ko_sidebar_guide_vs_formats(inputs)
	return ja_sidebar_guide_vs_formats(inputs)
});